export default {
  comprovante: () => import("/vercel/path0/layouts/comprovante.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  questionnaire: () => import("/vercel/path0/layouts/questionnaire.vue").then(m => m.default || m)
}